import { ICampusesDatasource } from '../../sections/datasources/campuses_datasource';
import { IHash, IQuery, IQueryMediator } from 'core-ts-types';
import { ILocationsDatasource } from '../../sections/datasources/locations_datasource';
import { ISection, ICampusSectionGroup } from '../../../interfaces/scheduler_interfaces';
import { ISectionAvailabilityDatasource } from '../../sections/datasources/section_availability_datasource';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import {
  ISectionTime,
  IRawLocation,
  ILocation,
  IAllSectionsDisplayedByCampus
} from '../../../interfaces/scheduler_interfaces';
import { ISectionTimesDatasource } from '../../sections/datasources/section_times_datasource';
import { ITermCourse } from '../../../interfaces/scheduler_interfaces';
import { ITermSectionTypesDatasource } from '../../term_courses/datasources/term_section_types_datasource';
import { TermCourseQuery } from '../../term_courses/queries/term_courses_query';
import { UnscheduledSectionFilters } from '../filters/unscheduled_section_filters';
import { UnscheduledSectionsVisibilityModel } from '../models/unscheduled_sections_visibility_model';
import * as _4 from 'lodash4';
import { SectionSwapServant } from '../../../swap/servants/section_swap_servant';
import { SelectedSectionFiltersModel } from '../../../components/section_filters/models/selected_section_filters_model';
export class UnscheduledSectionsQuery implements IQuery {
  private _result: {
    available: ICampusSectionGroup[];
    conflicting: ICampusSectionGroup[];
    full: ICampusSectionGroup[];
    all: ISection[];
    areAllSectionsDisplayedByCampus: IAllSectionsDisplayedByCampus[];
    sectionsCount: {
      available: number;
      conflicting: number;
      full: number;
    };
  };

  constructor(
    QueryMediator: IQueryMediator,
    private ngUnscheduledSectionFilters: UnscheduledSectionFilters,
    private ngSectionAvailabilityDatasource: ISectionAvailabilityDatasource,
    private ngCampusesDatasource: ICampusesDatasource,
    private ngSectionsDatasource: ISectionsDatasource,
    private ngLocationsDatasource: ILocationsDatasource,
    private ngSectionTimesDatasource: ISectionTimesDatasource,
    private ngTermSectionTypesDatasource: ITermSectionTypesDatasource,
    private ngTermCourseQuery: TermCourseQuery,
    private $stateParams: ng.ui.IStateParamsService,
    private $state: ng.ui.IStateService,
    private ngSectionSwapServant: SectionSwapServant,
    private ngUnscheduledSectionsVisibilityModel: UnscheduledSectionsVisibilityModel,
    private ngSelectedSectionFiltersModel: SelectedSectionFiltersModel
  ) {
    QueryMediator.registerQuery(
      this,
      ngSectionAvailabilityDatasource,
      ngSectionsDatasource,
      ngLocationsDatasource,
      ngCampusesDatasource,
      ngSectionTimesDatasource,
      ngSelectedSectionFiltersModel
    );
  }

  clear() {
    this._result = {
      available: [],
      conflicting: [],
      full: [],
      all: [],
      areAllSectionsDisplayedByCampus: [],
      sectionsCount: {
        available: 0,
        conflicting: 0,
        full: 0
      }
    };
  }
  run() {
    const allSections = this.ngSectionsDatasource.metasource().derived();

    let allSectionsWithSectionAvailability = allSections;

    if (!this.ngSectionSwapServant.isInSwapMode()) {
      // Filter courses for rescheduling course
      const sectionsNotConflictingWithSession = _4.filter(
        allSectionsWithSectionAvailability,
        (section) =>
          !_4.get(section, '_availability.is_conflicting_with_session', false) &&
          !_4.get(section, '_availability.is_withdrawn', false)
      );
      allSectionsWithSectionAvailability = sectionsNotConflictingWithSession;
    }
    const sectionTypeId = parseInt(this.$stateParams.sectionTypeId, 10);
    const courseId = parseInt(this.$stateParams.courseId, 10);
    const allSectionsForSelectedCourse = this.ngUnscheduledSectionFilters.filterSectionsByCourse(
      _4.compact(allSectionsWithSectionAvailability),
      courseId
    );

    if (this.ngSectionSwapServant.isInSwapMode()) {
      let allUnregisteredSectionsForSelectedCourse =
        this.ngUnscheduledSectionFilters.filterRegisteredSections(allSectionsForSelectedCourse);
      allUnregisteredSectionsForSelectedCourse =
        this.ngUnscheduledSectionFilters.filterSwapSections(allSectionsForSelectedCourse);
    }

    // If sectionTypeId is 0 it had no section type otherwise filter out just the sections of this section type.
    let allSectionsOfSectionType =
      sectionTypeId > 0
        ? this.ngUnscheduledSectionFilters.filterSectionsBySectionType(allSectionsForSelectedCourse, sectionTypeId)
        : allSectionsForSelectedCourse;
    allSectionsOfSectionType = this.ngUnscheduledSectionFilters.applySectionFilters(allSectionsOfSectionType);
    const availableSections = this.ngUnscheduledSectionFilters.filterAvailableSections(allSectionsOfSectionType);
    const availableNonLimited = this.ngUnscheduledSectionFilters.groupByCampuses(availableSections);
    const available = this.ngUnscheduledSectionFilters.limitByThreshold(
      availableNonLimited,
      this.ngUnscheduledSectionsVisibilityModel
    );

    const conflictingSections = this.ngUnscheduledSectionFilters.filterConflictingSections(allSectionsOfSectionType);
    const conflictingNonLimited = this.ngUnscheduledSectionFilters.groupByCampuses(conflictingSections);
    const conflicting = this.ngUnscheduledSectionFilters.limitByThreshold(
      conflictingNonLimited,
      this.ngUnscheduledSectionsVisibilityModel
    );
    const fullSections = this.ngUnscheduledSectionFilters.filterFullSections(allSectionsOfSectionType);
    const fullNonLimited = this.ngUnscheduledSectionFilters.groupByCampuses(fullSections);
    const full = this.ngUnscheduledSectionFilters.limitByThreshold(
      fullNonLimited,
      this.ngUnscheduledSectionsVisibilityModel
    );

    const allSectionsDisplayedByCampusFlags = this.ngUnscheduledSectionFilters.allSectionsDisplayedByCampus(
      availableNonLimited,
      available
    );

    this._result = {
      available,
      conflicting,
      full,
      all: allSectionsOfSectionType,
      areAllSectionsDisplayedByCampus: allSectionsDisplayedByCampusFlags,
      sectionsCount: {
        available: availableSections.length,
        conflicting: conflictingSections.length,
        full: fullSections.length
      }
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngUnscheduledSectionsQuery', UnscheduledSectionsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/unscheduled_sections/queries/unscheduled_sections_query.ts